import { createContext } from 'react'
import type { SupportedCurrency } from '@/lib/format'

export interface CurrencyContextValue {
  currency: SupportedCurrency
  setCurrency: (currency: SupportedCurrency) => void
  formatValue: (value: number | null) => string
}

export const CurrencyContext = createContext<CurrencyContextValue | undefined>(undefined)
